import { State as StoreState } from '@app/app.reducer';
import { createFeatureSelector, createSelector, State } from '@ngrx/store';
import { getLocalStorageObject } from '@shared/app-utils';

export const createDynamicFeatureSelector = <T>(featureKey: string, initialStoreState: T) =>
  createSelector(
    (state: State<StoreState>) => state,
    (state) =>
      state[featureKey] !== undefined
        ? createFeatureSelector<T>(featureKey)(state)
        : getLocalStorageObject(featureKey) || initialStoreState
  );
